const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const SysRoleList = () => import(/* webpackChunkName: "role" */ './system/view/index.vue');
const SysRoleAdd = () => import(/* webpackChunkName: "role" */ './system/view/add.vue');
const AppRoleList = () => import(/* webpackChunkName: "role" */ './app/view/index.vue');
const AppRoleAdd = () => import(/* webpackChunkName: "role" */ './app/view/add.vue');

export const ROUTE_NAME_ROLE = {
    SYSTEM: {
        INDEX: 'SysRoleList',
        ADD: 'SysRoleAdd'
    },
    APP: {
        INDEX: 'AppRoleList',
        ADD: 'AppRoleAdd'
    }
} as const;

export default [
    {
        path: '/system/role',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_ROLE.SYSTEM.INDEX,
                component: SysRoleList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_ROLE.SYSTEM.ADD,
                component: SysRoleAdd,
                meta: { requiresAuth: true }
            }
        ]
    },
    {
        path: '/app/:appId/role',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_ROLE.APP.INDEX,
                component: AppRoleList,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_ROLE.APP.ADD,
                component: AppRoleAdd,
                meta: { requiresAuth: true }
            }
        ]
    }
];
